import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

import { notify } from "../../functions/function";
import { connect } from "react-redux";
import { dispatchDeleteClient } from "./helperFunctions";
import axios from "axios";

import { iStaffBaseURL } from "src/constants/Urls";

import SmallLoadingSpinner from "../../components/SmallLoadingSpinner";

const DeleteClientModal = ({
  show,
  handleClose,
  event,
  row,
  userToken,
  clients,
  dispatch,
}) => {
  /* Event refers to the user movement (i.e. clicking and dragging) */
  /* using same names as model fields in Django */

  const [state, setState] = useState({
    loading: false,
  });

  const handleDelete = () => {
    setState({ ...state, loading: true });
    if (row.user.id) {
      axios
        .delete(iStaffBaseURL + "/handler/client/" + row.user.id + "/", {
          headers: { Authorization: "Token " + userToken },
        })
        .then((response) => {
          console.log(response);
          notify("Success", "Client was successfully deleted.", "success");
          dispatchDeleteClient(dispatch, clients, row.id);
          setState({ ...state, loading: false });
        })
        .catch((error) => {
          setState({ ...state, loading: false });
          notify(
            "Error",
            "Client failed to be deleted. Please try again",
            "danger"
          );
        });
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size={"l"}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Delete Client </Modal.Title>
      </Modal.Header>

      <Modal.Footer>
        {!state.loading ? (
          <>
            <div style={{ alignItems: "center" }}>
              <Button
                variant="primary"
                size="lg"
                block
                onClick={() => {
                  handleDelete();
                }}
              >
                Yes
              </Button>
            </div>
            <div>
              <Button variant="danger" size="lg" block onClick={handleClose}>
                No
              </Button>
            </div>
          </>
        ) : (
          <SmallLoadingSpinner />
        )}
      </Modal.Footer>
    </Modal>
  );
};

function mapStateToProps(state) {
  return {
    userToken: state.userTokenReducer.userToken,
    clients: state.userPlacementsReducer.clients,
  };
}

export default connect(mapStateToProps)(DeleteClientModal);
